module.exports = __webpack_public_path__ + "media/images/billing/banner-free-641f026febefc2f6a96ccfa672d35201.svg";